import './WorkdayJobs.scss'

import { useEffect, useState } from 'react'

import Table from './Table'
import WorkdayJobsFilter from './WorkdayJobsFilter'

export type WorkdayJobsProps = {
  resultlist?: string
  hidelocation?: string
  hidejobtype?: string
  hidetypeofcontract?: string
  hideexperience?: string
  hidejobfunction?: string
  hidebusinessunit?: string
  hideproductgroup?: string
}

export default function WorkdayJobs({
  resultlist,
  hidelocation,
  hidejobtype,
  hidetypeofcontract,
  hideexperience,
  hidejobfunction,
  hidebusinessunit,
  hideproductgroup,
}: WorkdayJobsProps) {
  const headerLabels = {
    applyNowUrl: 'Apply',
    businessUnit: 'Business Unit',
    experience: 'Experience',
    jobFunction: 'Job Function',
    jobType: 'Job Type',
    locations: 'Location',
    path: 'Path',
    productGroup: 'Product Group',
    title: 'Title',
    typeOfContract: 'Contract Type',
  }
  const filterFields = ['locations', 'jobType', 'typeOfContract', 'experience', 'jobFunction', 'businessUnit', 'productGroup']

  const [filters, setFilters] = useState({})
  const [workdayjobs, setWorkdayJobs] = useState([])
  const [visibleCount, setVisibleCount] = useState(20)
  const [tempSelections, setTempSelections] = useState({})
  const [openDropdown, setOpenDropdown] = useState(null)

  useEffect(() => {
    if (resultlist) {
      const fixedJson = resultlist.replace(/([{,])\s*(\w+)\s*:/g, '$1"$2":').replace(/'/g, '"')

      try {
        const parsed = JSON.parse(fixedJson)
        setWorkdayJobs(parsed)
      } catch (error) {
        console.error('Failed to parse workdayjobsdata:', error)
      }
    }
  }, [])

  const handleLoadMore = () => {
    setVisibleCount(prevCount => prevCount + 20)
  }

  const getOptions = field => {
    return Array.from(new Set(workdayjobs.map(job => job[field]).filter(Boolean)))
  }

  const toggleDropdown = field => {
    setOpenDropdown(openDropdown === field ? null : field)
    setTempSelections(prev => ({ ...prev, [field]: filters[field] || [] }))
  }

  const toggleOption = (field, value) => {
    setTempSelections(prev => {
      const current = prev[field] || []
      const updated = current.includes(value) ? current.filter(v => v !== value) : [...current, value]
      return { ...prev, [field]: updated }
    })
  }

  const resetField = field => {
    setTempSelections(prev => ({ ...prev, [field]: [] }))
  }

  const applyFilter = field => {
    setFilters(prev => ({
      ...prev,
      [field]: tempSelections[field],
    }))
    setOpenDropdown(null)
  }

  const applyFooterFilter = filter => {
    setFilters(prev => ({
      ...prev,
      [filter]: tempSelections[filter],
    }))
    setOpenDropdown(null)
  }

  const filteredJobs = workdayjobs.filter(job =>
    Object.entries(filters).every(([key, value]) => !value || value?.length === 0 || value?.includes(job[key])),
  )

  const visibleJobs = filteredJobs.slice(0, visibleCount)
  return (
    <>
      <WorkdayJobsFilter
        getOptions={getOptions}
        openDropdown={openDropdown}
        toggleDropdown={toggleDropdown}
        headerLabels={headerLabels}
        filterFields={filterFields}
        resetField={resetField}
        applyFilter={applyFilter}
        applyFooterFilter={applyFooterFilter}
        filteredJobscount={filteredJobs.length}
        filters={filters}
        toggleOption={toggleOption}
        tempSelections={tempSelections}
        hidelocation={hidelocation}
        hidejobtype={hidejobtype}
        hidetypeofcontract={hidetypeofcontract}
        hideexperience={hideexperience}
        hidejobfunction={hidejobfunction}
        hidebusinessunit={hidebusinessunit}
        hideproductgroup={hideproductgroup}
      />
      <Table
        visibleJobs={visibleJobs}
        visibleCount={visibleCount}
        totalJobs={filteredJobs.length}
        handleLoadMore={handleLoadMore}
        hidelocation={hidelocation}
        hidejobtype={hidejobtype}
        hidetypeofcontract={hidetypeofcontract}
        hideexperience={hideexperience}
        hidejobfunction={hidejobfunction}
        hidebusinessunit={hidebusinessunit}
        hideproductgroup={hideproductgroup}
      />
    </>
  )
}
